/* PlushBeds Customatic comparison. No fetches, cart mutation or global currency formatter.
 * All prices and product/variant URLs are rendered by Shopify for the current market. */
(function () {
  'use strict';
  const namespace = '__pbCustomaticCompareV1';
  if (window[namespace]) { window[namespace].scan(document); return; }
  const instances = new Map();
  const selector = '[data-pb-customatic-compare]';
  const keys = ['contour', 'synergy', 'harmony'];
  const allowedSizes = ['twin_xl', 'queen', 'king', 'split_king'];
  const publicSize = key => key.replaceAll('_', '-');
  function readSize(fallback) {
    const key = (new URL(window.location.href).searchParams.get('size') || '').replaceAll('-', '_');
    return allowedSizes.includes(key) ? key : fallback;
  }
  function init(root) {
    if (instances.has(root)) return;
    const json = root.querySelector('[data-pbc-data]');
    let data;
    try { data = JSON.parse(json.textContent); } catch (_) { return; }
    if (!keys.every(key => data.models[key] && allowedSizes.every(size => data.models[key].sizes[size]))) return;
    const controller = new AbortController();
    const on = (el, event, fn) => el.addEventListener(event, fn, { signal: controller.signal });
    const all = s => root.querySelectorAll(s);
    const setText = (s, text) => all(s).forEach(el => { el.textContent = text; });
    const announcement = root.querySelector('[data-pbc-announcement]');
    function update(size, announce, writeUrl) {
      if (!allowedSizes.includes(size)) return;
      all('[data-pbc-size]').forEach(el => { el.value = size; });
      setText('[data-pbc-size-label]', data.labels[size]);
      const notices = [];
      keys.forEach(key => {
        const model = data.models[key], state = model.sizes[size];
        all(`[data-pbc-price="${key}"]`).forEach(el => {
          el.textContent = state.price;
          el.classList.toggle('is-unavailable', !state.id);
        });
        setText(`[data-pbc-status="${key}"]`, state.status);
        all(`[data-pbc-link="${key}"]`).forEach(el => {
          el.href = state.url;
          const action = el.classList.contains('secondary') ? `View details for ${model.name}` : el.classList.contains('primary') ? state.cta : `${model.name} details`;
          el.setAttribute('aria-label', `${action}, ${data.labels[size]}${state.status ? ', ' + state.status : ''}`);
        });
        setText(`[data-pbc-cta="${key}"]`, state.cta);
        notices.push(`${model.name}: ${state.price}${state.status ? ', ' + state.status : ''}`);
      });
      setText('[data-pbc-dimensions]', data.dimensions[size]);
      keys.forEach(key => setText(`[data-pbc-weight="${key}"]`, data.weights[key][size]));
      if (announce && announcement) announcement.textContent = `${data.labels[size]}. ${notices.join('. ')}.`;
      if (writeUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('size', publicSize(size));
        window.history.replaceState(window.history.state, '', url);
      }
      root.dataset.selectedSize = size;
      root.dispatchEvent(new CustomEvent('pb:comparison:size-change', { bubbles: true, detail: { size, sectionId: root.dataset.sectionId } }));
    }
    all('[data-pbc-size]').forEach(el => {
      on(el, 'change', () => update(el.value, true, true));
      el.disabled = false;
    });
    const filters = [...all('[data-pbc-group]')];
    filters.forEach(button => on(button, 'click', () => {
      const group = button.dataset.pbcGroup;
      filters.forEach(b => { b.classList.toggle('active', b === button); b.setAttribute('aria-pressed', String(b === button)); });
      all('[data-group-row], [data-rowgroup]').forEach(row => { row.hidden = group !== 'all' && (row.dataset.groupRow || row.dataset.rowgroup) !== group; });
      if (announcement) announcement.textContent = `${button.textContent.trim()} shown for all three bases.`;
    }));
    const toolbar = root.querySelector('[data-pbc-filters]');
    if (toolbar) toolbar.hidden = false;
    on(window, 'popstate', () => update(readSize(data.defaultSize), false, false));
    update(readSize(data.defaultSize), false, false);
    instances.set(root, controller);
  }
  function scan(scope) {
    if (scope.matches && scope.matches(selector)) init(scope);
    scope.querySelectorAll(selector).forEach(init);
  }
  function unload(scope) {
    instances.forEach((controller, root) => {
      if (scope === root || scope.contains(root)) { controller.abort(); instances.delete(root); }
    });
  }
  window[namespace] = { scan, unload };
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => unload(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
})();
